export default __webpack_public_path__ + "static/media/lightswitch.1b36d2ed.wav";